import React from 'react';
import { Popup } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { SVGIcon } from '@eeacms/volto-chatbot/ChatBlock/utils';

import FileIcon from '@eeacms/volto-chatbot/icons/file.svg';
import GlobeIcon from '@eeacms/volto-chatbot/icons/globe.svg';

import { chatbotMessages } from './messages';

const SourceDetails_ = ({ source, index, luxon }) => {
  const intl = useIntl();
  const { link, blurb, updated_at, source_type, semantic_identifier } = source || {};
  const sourceTitle = semantic_identifier || intl.formatMessage(chatbotMessages.untitledDocument);
  const parsedDate = updated_at ? luxon.DateTime.fromISO(updated_at) : null;
  const relativeTime = parsedDate?.setLocale(intl.locale).toRelative();
  const isLinkType = source_type === 'web';
  const isDocumentType = source_type === 'file';

  const renderIcon = () => {
    if (isLinkType) {
      return <SVGIcon name={GlobeIcon} size="16" alt={intl.formatMessage(chatbotMessages.webIconAlt)} />;
    }
    if (isDocumentType) {
      return <SVGIcon name={FileIcon} size="16" alt={intl.formatMessage(chatbotMessages.fileIconAlt)} />;
    }
    return null;
  };

  const sourceContent = (
    <>
      {blurb && (
        <div className="source-desc">
          <span>{blurb}</span>
        </div>
      )}
      {updated_at && (
        <div className="source-date">
          <span>{relativeTime}</span>
        </div>
      )}
    </>
  );

  return (
    <>
      {isLinkType ? (
        <a href={link} rel="noreferrer" target="_blank" className="source source-link">
          <div className="source-header">
            <span className="chat-citation">{index}</span>
            <div className="source-title" title={sourceTitle}>
              {sourceTitle}
            </div>
            {renderIcon()}
          </div>
          {sourceContent}
        </a>
      ) : (
        <div className="source">
          <div className="source-header">
            <Popup on="click" wide="very" content={intl.formatMessage(chatbotMessages.sourceWithoutLink)} trigger={<span className="chat-citation">{index}</span>} popper={{ id: 'chat-citation-popup' }} />
            <div className="source-title" title={sourceTitle}>
              {sourceTitle}
            </div>
            {renderIcon()}
          </div>
          {sourceContent}
        </div>
      )}
    </>
  );
};

export const SourceDetails = injectLazyLibs(['luxon'])(SourceDetails_);

export default SourceDetails;
